// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kvMAsx178YeEhSAy{margin:0 auto;max-width:365px;text-align:center}.htQCUaADYWVXhUKF{margin:0 auto;width:878px}.htQCUaADYWVXhUKF .diwXjrFwzINL52qF{display:grid;grid-template-columns:288px 50px 1fr 142px}.htQCUaADYWVXhUKF .diwXjrFwzINL52qF .RUrheGqXuEU8lrJf{width:100%}.NxU_lpjgz4WO8vjm{display:grid;grid-template-columns:32px 1fr}.NxU_lpjgz4WO8vjm .JCoFfixpHsAqWeC5{display:flex;flex-direction:column;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `kvMAsx178YeEhSAy`,
	"directoryWrapper": `htQCUaADYWVXhUKF`,
	"controls": `diwXjrFwzINL52qF`,
	"saveButton": `RUrheGqXuEU8lrJf`,
	"nameColumn": `NxU_lpjgz4WO8vjm`,
	"employeeName": `JCoFfixpHsAqWeC5`
};
export default ___CSS_LOADER_EXPORT___;
